<template>
  <div>
    <lk-modal v-model="status"
    :footer-hide='true'
    :closable='false'
    :mask-closable='false'
    width="340"
    >
    <div class="container">

      <div class="title">
        <span
          :class="{
            'iconfont':true,
            'alert':type==='alert',
            'info':type==='info'
          }">&#xe613;</span>
        <span class="word">提示</span>
      </div>
      <div class="content">
        {{content}}
      </div>
      <div class="btns">
        <lk-button @click="cancel" v-if="!noCancel" class="cancel">{{cancelText}}</lk-button>
        <lk-button type='primary' @click="confirm" :loading='confirmLoading'>{{confirmText}}</lk-button>
      </div>
    </div>
    </lk-modal>
  </div>
</template>
<script>
export default {
  name: 'dtpModal',
  props: {
    confirmLoading: {
      type: Boolean,
      default: false,
    },
    noCancel: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Boolean,
      // default: true,
    },
    content: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'info',
    },
    confirmText: {
      type: String,
      default: '确定',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
  },
  model: {
    prop: 'status',
    event: 'click',
  },
  data() {
    return {};
  },
  methods: {
    cancel() { // 实现model绑定
      this.$emit('click', false);
      this.$nextTick(() => {
        this.$emit('handleCancel');
      });
      // this.status = false;
    },
    confirm() {
      this.$emit('confirm', true);
    },
  },
  created() {
    // console.log(this.value);
  },
};
</script>
<style lang="less" scoped>
.container{
  height: 136px;
  position: relative;
  .btns{
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 136px;
  .cancel{
    margin-right: 16px
  }

  }
.title{
  // line-height: 18px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  .icon{
    margin-right: 16px;
    color: #1890FF
  }
  .alert{
    color: #FF4D07
  }
  .info{
    color: #1890FF
    // color: #FF4D07
  }
  .word{
    font-size: 14px;
    color: rgba(0,0,0,0.75);
    margin-left: 8px
  }
}
  .content{
    padding: 0 33px;
    width: 100%;
  }
}
</style>
